import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';

function TipUni(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                    
                    document.title = getTitle(confPantalla.config.trad, confPantalla.tipuni.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.tipuni.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.tipuni.hijo.estadoform);                              
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.tipuni.padre.urls);
                                saveFormularioPrin(confPantalla.tipuni.padre.modelform);
                                saveFormularioHijo(confPantalla.tipuni.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.tipuni.padre.urls, confPantalla.tipuni.hijo.urls, confPantalla.tipuni.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);    
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.tipuni.section.titulo } icono={ confPantalla.tipuni.section.icono } col={ confPantalla.tipuni.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.tipuni.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.tipuni.padre.btnform.new }
                                        btnSave={ confPantalla.tipuni.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.tipuni.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.tipuni.padre.btnform.delete }
                                        btnClone={ confPantalla.tipuni.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.tipuni.padre.urls, confPantalla.tipuni.padre.modelform, confPantalla.tipuni.padre.tabla, confPantalla.tipuni.hijo.modelform, confPantalla.tipuni.title) }
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.tipuni.padre.modelform, true, confPantalla.tipuni.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.tipuni.padre.urls, confPantalla.tipuni.padre.modelform, confPantalla.tipuni.padre.tabla, confPantalla.tipuni.title) }
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipuni.padre.controles.pad.id }    
                                        name=        { confPantalla.tipuni.padre.controles.pad.name }   
                                        label=       { confPantalla.tipuni.padre.controles.pad.label }    
                                        placeholder= { confPantalla.tipuni.padre.controles.pad.placeholder }
                                        col=         { confPantalla.tipuni.padre.controles.pad.col } 
                                        isClearable= { confPantalla.tipuni.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.tipuni.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.tipuni.padre.controles.pad.datatype }
                                        data=        { confPantalla.tipuni.padre.controles.pad.data }
                                        required=    { confPantalla.tipuni.padre.controles.pad.required } 
                                        disabled=    { confPantalla.tipuni.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.tipuni.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.tipuni.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipuni.padre.controles.nom.id }   
                                        type=       { confPantalla.tipuni.padre.controles.nom.type }  
                                        name=       { confPantalla.tipuni.padre.controles.nom.name }   
                                        label=      { confPantalla.tipuni.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.tipuni.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.tipuni.padre.controles.nom.col } 
                                        required=   { confPantalla.tipuni.padre.controles.nom.required }
                                        readonly=   { confPantalla.tipuni.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.tipuni.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.tipuni.padre.controles.nom_en.id }   
                                        type=       { confPantalla.tipuni.padre.controles.nom_en.type }  
                                        name=       { confPantalla.tipuni.padre.controles.nom_en.name }   
                                        label=      { confPantalla.tipuni.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.tipuni.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.tipuni.padre.controles.nom_en.col } 
                                        required=   { confPantalla.tipuni.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.tipuni.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.tipuni.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>
                                <FormRow clases="">
                                    <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.sto  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.tipuni.padre.controles.sto.id }    
                                        name=        { confPantalla.tipuni.padre.controles.sto.name }   
                                        label=       { confPantalla.tipuni.padre.controles.sto.label }    
                                        placeholder= { confPantalla.tipuni.padre.controles.sto.placeholder }
                                        col=         { confPantalla.tipuni.padre.controles.sto.col } 
                                        isClearable= { confPantalla.tipuni.padre.controles.sto.isclearable }
                                        isSearchable={ confPantalla.tipuni.padre.controles.sto.issearchable }
                                        dataType=    { confPantalla.tipuni.padre.controles.sto.datatype }
                                        data=        { confPantalla.tipuni.padre.controles.sto.data }
                                        required=    { confPantalla.tipuni.padre.controles.sto.required } 
                                        disabled=    { confPantalla.tipuni.padre.controles.sto.disabled }
                                        readOnly =   { confPantalla.tipuni.padre.controles.sto.readonly }
                                        disablethisid={confPantalla.tipuni.padre.controles.sto.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    /> 
                                </FormRow>                            
                            </Formulario>
                            <MiDataTable 
                                formulario={formularioPrin}
                                estadoForm= { estadoFormPrin }
                                id={"tipuni"}
                                columnas={confPantalla.tipuni.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.tipuni.padre.datatable.buttons}
                                ordering={confPantalla.tipuni.padre.datatable.ordering}
                                order={confPantalla.tipuni.padre.datatable.order}
                                searching={confPantalla.tipuni.padre.datatable.searching}
                                paging={confPantalla.tipuni.padre.datatable.paging}
                                select={confPantalla.tipuni.padre.datatable.select}
                                pagelength={confPantalla.tipuni.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.tipuni.padre.urls, confPantalla.tipuni.hijo.urls, confPantalla.tipuni.padreshijos, confPantalla.tipuni.hijo.modelform, confPantalla.tipuni.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.tipuni.padre.urls, confPantalla.tipuni.padre.modelform, confPantalla.tipuni.padre.tabla, confPantalla.tipuni.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.tipuni.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default TipUni